import { useMutation } from "@tanstack/react-query";
import { deviceApis } from "../../../../../../shared/apis/device/apis";

export function useDispatchMutation() {
  const { mutate: deleteDevice } = useMutation(deviceApis.shipment.deleteDispatchDevice);

  return { deleteDevice };
}
